import * as React from 'react';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { GroupedComponentsValidator } from 'sos-common/js/components/FormControls/GroupedComponentsValidator';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { IAppContext } from '../Types/Intyg.types';

export interface IAntalIntygPerSprakProps {
  intygPerSprakModels: IntygPerSprakModel[];
  id: number;
  skickaTillFolkbokforing?: boolean;
}

export interface IAntalIntygPerSprakState extends FormSectionBaseState {}

export interface IntygPerSprakModel {
  fieldName: string;
  label: string;
  value: number;
}

const ANTAL_OPTIONS = [
  { key: '0', text: '0' },
  { key: '1', text: '1' },
  { key: '2', text: '2' },
  { key: '3', text: '3' },
  { key: '4', text: '4' },
  { key: '5', text: '5' },
];

enum LocalFieldName {
  GroupedSelectBox = 'GroupedSelectBox',
}

export class AntalIntygPerSprak extends FormSectionBase<IAntalIntygPerSprakProps, IAntalIntygPerSprakState> {
  constructor(props: IAntalIntygPerSprakProps, context: IAppContext) {
    super(props);

    // Initial validation
    const errors = new Map(this.emptyErrorsMap);
    const intygCount = this.getIntygCount(props.intygPerSprakModels);
    if (intygCount === 0) {
      errors.set(LocalFieldName.GroupedSelectBox, {
        showMessage: context.submitButtonIsClicked,
        errorMessage: context.Translate('error_intyg_count'),
      });
    }

    this.state = {
      errors: errors,
    };
  }

  getIntygCount = (sprakModel: IntygPerSprakModel[]) => {
    let intygCount = 0;
    sprakModel.forEach((model) => {
      intygCount += model.value;
    });
    return intygCount;
  };

  onChangeAntal = (field: FormField<string>) => {
    const { intygPerSprakModels, skickaTillFolkbokforing } = this.props;
    const { Translate, updateModelUsingKeyValue } = this.context;
    const sprakModelClone = intygPerSprakModels.slice();
    field.fieldName = field.fieldName.replace(/_\d+$/, '');
    const fieldModel = sprakModelClone.find((x) => x.fieldName === field.fieldName);
    fieldModel.value = parseInt(field.value);
    const intygCount = this.getIntygCount(sprakModelClone);
    const errors = new Map(this.state.errors);

    if (intygCount === 0) {
      errors.set(LocalFieldName.GroupedSelectBox, {
        showMessage: true,
        errorMessage: Translate('error_intyg_count'),
      });
    } else {
      errors.delete(LocalFieldName.GroupedSelectBox);
    }
    this.setState({ errors }, () => {
      if (skickaTillFolkbokforing) {
        updateModelUsingKeyValue(field.fieldName.replace(/_\d+$/, ''), parseInt(field.value));
      } else {
        updateModelUsingKeyValue('adresser', this.getUpdatedAdressObject(field.fieldName, parseInt(field.value)));
      }
    });
  };

  getUpdatedAdressObject = (fieldName: string, value: any) => {
    const leveransAdressArrClone = this.context.model.adresser.slice();
    const leveransAdressClone = leveransAdressArrClone.find((x) => x.id === this.props.id);
    if (!leveransAdressClone) return console.error('Could not find a leveransadress with given id: ', this.props.id);
    leveransAdressClone[fieldName] = value;
    return leveransAdressArrClone;
  };

  public render() {
    const { Translate } = this.context;
    const { intygPerSprakModels, id } = this.props;
    return (
      <div>
        <h3 className="like-a-label">
          {Translate('valjantalforadress')} {'(obligatoriskt)'}
        </h3>

        <GroupedComponentsValidator errorMessage={this.getErrorMessage(LocalFieldName.GroupedSelectBox)}>
          {intygPerSprakModels.map((model, index) => {
            return (
              <SelectBox
                key={`${id}_${model.fieldName}_${index}`}
                className="small-input-with-right-aside-label m-b-1"
                options={ANTAL_OPTIONS}
                id={`${id}_${model.fieldName}`}
                //fieldName={model.fieldName}
                fieldName={`${model.fieldName}_${id}`}
                label={model.label}
                onChange={this.onChangeAntal}
                disableDefaultOption={true}
                value={model.value?.toString()}
                isRequired={true}
              />
            );
          })}
        </GroupedComponentsValidator>

        {intygPerSprakModels.length === 0 && <div>{Translate('valjSprakTidigareIFormularet')}</div>}
      </div>
    );
  }
}
